import classNames from 'classnames';
import { type FC, type ReactNode, useMemo } from 'react';
import { IconContext, type IconContextType, type IconSize } from '../Icon/Icon';

export type InputAdornmentProps = {
  children: ReactNode;
  position?: 'start' | 'end';
  className?: string;
  iconSize: IconSize;
};

export const InputAdornment: FC<InputAdornmentProps> = ({
  position = 'start',
  children,
  className,
  iconSize,
}) => {
  const iconContext = useMemo<IconContextType>(
    () =>
      ({
        iconSize: iconSize,
      }) satisfies IconContextType,
    [iconSize],
  );

  const separator = typeof children === 'string';

  return (
    <IconContext.Provider value={iconContext}>
      <div
        className={classNames(
          separator &&
            position === 'start' &&
            'border-r border-r-default pr-3xs',
          separator && position === 'end' && 'border-l border-l-default pl-3xs',
          className,
        )}
      >
        {children}
      </div>
    </IconContext.Provider>
  );
};
